import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { SVGFC } from '@repo/toolkit/types'

const PeopleTwoIcon: SVGFC = ({ color = tailwindColors.secondary.DEFAULT, ...props }) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.2 9.25C7.2 8.38161 7.53136 7.55269 8.11511 6.94462C8.69819 6.33724 9.48457 6 10.3 6C11.1154 6 11.9018 6.33724 12.4849 6.94462C13.0686 7.55269 13.4 8.38161 13.4 9.25C13.4 10.1184 13.0686 10.9473 12.4849 11.5554C11.9018 12.1628 11.1154 12.5 10.3 12.5C9.48457 12.5 8.69819 12.1628 8.11511 11.5554C7.53136 10.9473 7.2 10.1184 7.2 9.25ZM4.5 19.6299C4.5 17.0008 6.53956 14.9062 9.01469 14.9062H11.5853C14.0604 14.9062 16.1 17.0008 16.1 19.6299C16.1 19.8536 15.9308 20 15.7647 20H4.83531C4.66925 20 4.5 19.8536 4.5 19.6299ZM21.1366 20H17.9605C17.9863 19.8585 18 19.7123 18 19.5625V19.3281C18 17.8374 17.5044 16.4614 16.6731 15.375H17.4634C19.6742 15.375 21.5 17.2469 21.5 19.6006C21.5 19.8408 21.3177 20 21.1366 20ZM16.15 12.5C15.5597 12.5 15.0133 12.2975 14.5699 11.9514C15.0342 11.163 15.3 10.2374 15.3 9.25C15.3 8.54543 15.1642 7.87146 14.9168 7.25668C15.2868 7.05257 15.7059 6.9375 16.15 6.9375C17.5958 6.9375 18.8 8.16198 18.8 9.71875C18.8 11.2755 17.5958 12.5 16.15 12.5Z"
        stroke={color}
      />
    </svg>
  )
}

export default PeopleTwoIcon
